import { useMemo } from 'react';

import { useAdvanceFilters } from '@/_containers';

import { advFilters } from './components';

import { supportPagePreDefinedFilters, useFilterFormDefinition } from '../shared/filters';

const preAppliedFilters = {
  applied: true,
  valueToApply: 'match[status]=2,3,6,7,8',
  filterValue: 'Open|||Pending|||Waiting on Customer|||Waiting on Third Party|||Waiting on Developer',
  selectedType: {
    name: 'Match',
    value: 'match',
  },
};

export function usePage(isAllListPage: boolean) {
  const form = useFilterFormDefinition(isAllListPage ? supportPagePreDefinedFilters : undefined);

  const fixedAdvFilters = useMemo(() => {
    return advFilters.map((filter) => {
      if (filter.mainKey === 'status' && isAllListPage) {
        return {
          ...filter,
          ...preAppliedFilters,
        };
      }
      return filter;
    });
  }, [isAllListPage]);

  const filters = useAdvanceFilters(fixedAdvFilters);
  const { allFiltersStr, advFilterStr, advFiltersState, handleSubmitAdvFilters, handleClearAllAdvFilters, searching } =
    filters;

  return {
    form,
    allFiltersStr,
    advFilterStr,
    advFiltersState,
    handleSubmitAdvFilters,
    handleClearAllAdvFilters,
    searching,
  };
}
